(() => {
  const catalogSelector = '.mi-collection-products';
  const init = () => {
    const catalog = document.querySelector(catalogSelector);
    if (!catalog || catalog.dataset.madeDelegated === 'true') return;
    catalog.dataset.madeDelegated = 'true';
    /* Wishlist state is managed globally by made-in-wishlist.js. */

    const moveUnderwearToEnd = () => {
      catalog.querySelectorAll('.product-grid').forEach((grid) => {
        const items = [...grid.children].filter((item) => item.querySelector?.('[data-product-underwear]'));
        const isUnderwear = (item) => item.querySelector('[data-product-underwear]')?.dataset.productUnderwear === 'true';
        const firstUnderwear = items.findIndex(isUnderwear);
        if (firstUnderwear < 0 || !items.slice(firstUnderwear + 1).some((item) => !isUnderwear(item))) return;
        items.filter(isUnderwear).forEach((item) => grid.append(item));
      });
    };
    moveUnderwearToEnd();
    /* Reorder only the server-rendered first page. Re-running on every infinite-scroll append
       moved already-painted cards, causing layout jumps and re-layout while scrolling. */
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();
